import api from "../../../core/api/interceptors/axiosInterceptor";

/**
 * Get all delivery notes for the current user/company
 */
export const getDeliveryNotes = async () => {
  try {
    const response = await api.get("DeliveryNotes");
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get a single delivery note by ID
 */
export const getDeliveryNoteById = async (id) => {
  try {
    const response = await api.get(`DeliveryNotes/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Get the next delivery note number
 */
export const getNextDeliveryNoteNumber = async () => {
  try {
    const response = await api.get("/api/deliverynotes/next-number");
    return response.data;
  } catch (error) {
    return `DN-${Date.now() % 10000}`;
  }
};

/**
 * Add a new delivery note
 */
export const addDeliveryNote = async (deliveryNoteData) => {
  try {
    const response = await api.post("DeliveryNotes", deliveryNoteData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Update an existing delivery note
 */
export const updateDeliveryNote = async (id, deliveryNoteData) => {
  try {
    const response = await api.put(`DeliveryNotes/${id}`, deliveryNoteData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Delete a delivery note
 */
export const deleteDeliveryNote = async (id) => {
  try {
    const response = await api.delete(`DeliveryNotes/${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Send delivery note via email
 */
export const sendDeliveryNoteEmail = async (id, emailData) => {
  try {
    const response = await api.post(`DeliveryNotes/${id}/send-email`, emailData);
    return response.data;
  } catch (error) {
    throw error;
  }
};

/**
 * Search delivery notes
 */
export const searchDeliveryNotes = async (searchTerm) => {
  try {
    const response = await api.get("DeliveryNotes/search", {
      params: { query: searchTerm },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};
